import React, { useContext } from 'react';
import { NoteDialogWrapper, Div } from './styles/NoteDialog.style';
import {
  Dialog,
  Classes,
  H1,
  // TextArea,
  Button,
  // Checkbox,
  InputGroup,
  Intent,
  EditableText,
} from '@blueprintjs/core';
import {
  CLOSE_DIALOG,
  UPDATE_NOTE_TITLE,
  UPDATE_NOTE_DESCRIPTION,
  UPDATE_NOTE,
  SAVE_NOTE,
  UPDATE_NOTE_BACKGROUND_COLOR,
  // SHOW_NOTE_DESCRIPTION,
} from '../../actions';
import { AppContext } from '../../utils';
import cmsData from '../../cms';
import { ColorPicker } from '..';

const NoteDialog = () => {
  const { state, dispatch } = useContext(AppContext);
  const colorInput = 'test';
  const {
    isDialogOpen,
    noteTitle,
    noteDescription,
    noteBackgroundColor,
    showNoteDescription,
    updateNoteKey,
  } = state;
  const {
    p_edit_note_title,
    b_close,
    b_save,
    l_note_background_color,
  } = cmsData;

  return (
    <NoteDialogWrapper>
      <Dialog isOpen={isDialogOpen}>
        <Div className={Classes.DIALOG_BODY}>
          <H1>
            <InputGroup
              autoFocus
              large
              placeholder={p_edit_note_title}
              value={noteTitle}
              onChange={(evt) =>
                dispatch({
                  action: UPDATE_NOTE_TITLE,
                  payload: evt.target.value,
                })
              }
            />
          </H1>
          {/* <Checkbox
            checked={showNoteDescription}
            label="Add Description"
            onChange={(evt) =>
              dispatch({
                action: SHOW_NOTE_DESCRIPTION,
                payload: evt.target.value,
              })
            }
          /> */}
          {(noteDescription || showNoteDescription) && (
            <EditableText
              growVertically={true}
              large={true}
              fill={true}
              onChange={(evt) =>
                dispatch({
                  action: UPDATE_NOTE_DESCRIPTION,
                  payload: evt.target.value,
                })
              }
              value={noteDescription}
            />
          )}
        </Div>
        <Div className={Classes.DIALOG_FOOTER}>
          <ColorPicker
            label={l_note_background_color}
            value={noteBackgroundColor}
            id={colorInput}
            list={colorInput}
            onChange={(evt) => {
              dispatch({
                action: UPDATE_NOTE_BACKGROUND_COLOR,
                payload: evt.target.value,
              });
            }}
          />
          <datalist id={colorInput}>
            <option>#ff0000</option>
            <option>#00ff00</option>
            <option>#0000ff</option>
          </datalist>
          <Div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={() => dispatch({ action: CLOSE_DIALOG })}>
              {b_close}
            </Button>
            <Button
              intent={Intent.PRIMARY}
              onClick={() => {
                dispatch({
                  action:
                    updateNoteKey.toString().length > 0
                      ? UPDATE_NOTE
                      : SAVE_NOTE,
                });
              }}
            >
              {b_save}
            </Button>
          </Div>
        </Div>
      </Dialog>
    </NoteDialogWrapper>
  );
};

export default NoteDialog;
